/**
 * Crops a string to a specified limit
 * @param value String to be cropped
 * @param charLimit Number of characters to crop after
 * @returns Cropped string
 */
export function cropString(value: string, charLimit: number): string {
  return value.length > charLimit ? value.substring(0, charLimit - 1).trim() + '…' : value
}
